import { ActionReducer, INIT, UPDATE } from "@ngrx/store";
import { AppState } from "src/app/store/app.state";

export const hydrationMetaReducer = (
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> => {
  return (state, action) => {
    if (action.type === INIT || action.type === UPDATE) {
      const storageValue = localStorage.getItem("state");
      if (storageValue) {
        try {
          return JSON.parse(storageValue);
        } catch {
          localStorage.removeItem("state");
        }
      }
    }
    const nextState = reducer(state, action);
    localStorage.setItem("state", JSON.stringify(nextState));
    return nextState;
  };
};

export const clearState = (reducer: ActionReducer<AppState>): ActionReducer<AppState> => {
  return function (state: any, action: any): AppState {
    if (action.type === 'clearReducer') {
      state = undefined;
    }
    return reducer(state, action);
  };
}
